<template>
  <v-card color="blue-grey lighten-5">
    <v-row v-if="editMode" justify="space-between" align="center" class="py-2 px-6">
      <span class="invoicing-rule-panel-header">{{ header }}</span>
      <v-btn
        text
        color="primary"
        @click="openNewRuleDialog()"
      >
        <v-icon left>mdi-plus</v-icon>
        Add new rule
      </v-btn>
    </v-row>
    <v-expansion-panels
      multiple
      accordion>
      <InvoicingRulePanelItem
        v-for="(rule, i) in rules"
        :key="i"
        :rule="rule"
        :editMode="editMode"
        @modify="openRuleDialog(rule, i)"
        @delete="deleteRule(i)"
      ></InvoicingRulePanelItem>
    </v-expansion-panels>
    <InvoicingRuleDialog
      :isOpen="ruleDialog"
      :originalRule="selectedRule"
      :isNew="newRule"
      :isUpdating="isUpdating"
      @create="addRule"
      @save="modifySelectedRule"
      @close="closeRuleDialog"
    ></InvoicingRuleDialog>
  </v-card>
</template>

<script>
import InvoicingRulePanelItem from "./InvoicingRulePanelItem";
import InvoicingRuleDialog from "./InvoicingRuleDialog";

export default {
    props: {
        header: String,
        rules: Array,
        editMode: {
            type: Boolean,
            default: false
        }
    },
    components: {
        InvoicingRulePanelItem,
        InvoicingRuleDialog
    },
    data() {
        return {
            ruleDialog: false,
            selectedRule: {},
            selectedRuleIndex: -1,
            newRule: true,
            isUpdating: false,
            errorMessage: ""
        };
    },
    methods: {
        openNewRuleDialog() {
            this.selectedRule = {};
            this.newRule = true;
            this.ruleDialog = true;
        },
        openRuleDialog(rule, index) {
            this.selectedRule = rule;
            this.selectedRuleIndex = index;
            this.newRule = false;
            this.ruleDialog = true;
        },
        async deleteRule(index) {
            const rule = this.rules[index];
            if (!rule) return;
            if (!confirm("Are you sure that you want to delete rule?")) return;
            this.isUpdating = true;
            try {
                await this.$store.dispatch("invoiceRule/deleteRule", rule.id);
            } catch (e) {
                this.$emit("error", "Failed to delete rule.");
            } finally {
                this.isUpdating = false;
            }
        },
        async addRule(rule) {
            this.isUpdating = true;
            try {
                await this.$store.dispatch("invoiceRule/createRule", rule);
                this.closeRuleDialog();
            } catch (e) {
                this.$emit("error", "Failed to create rule.");
                this.isUpdating = false;
            }
        },
        modifySelectedRule(rule) {
            this.saveRule(rule);
        },
        async saveRule(rule) {
            this.isUpdating = true;
            try {
                await this.$store.dispatch("invoiceRule/updateRule", rule);
                this.closeRuleDialog();
            } catch (e) {
                this.$emit("error", "Failed to save rule.");
                this.isUpdating = false;
            }
        },
        closeRuleDialog() {
            this.isUpdating = false;
            this.selectedRule = {};
            this.ruleDialog = false;
        }
    }
};
</script>

<style>
.invoicing-rule-panel-header {
    font-size: 1rem;
    font-weight: bold;
}
</style>
